













import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldCheckboxButton'

  vue:
    props: ['value', 'errors', 'options']

    data: ->
      value_: @value || []

    methods:
      hiInputChange: ->
        @$emit 'input', @value_
        @$emit 'change', @value_

export default VueOptions.vue settings
